import Index from "../../pages-v1/Index";

export const Page = Index;
